import { Resolution } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { fetchPrices } from '@terminal/services/price/price-service';

const QUERY_KEY_PRICE_HISTORY = 'QUERY_KEY_PRICE_HISTORY';

interface UsePriceHistoryProps {
  entityTag: string;
  resolution?: Resolution;
  dateFrom?: string;
  dateTo?: string;
  ticker?: string;
  enabled?: boolean;
}

export const usePriceHistory = ({
  entityTag,
  resolution = '1D',
  dateFrom,
  dateTo,
  ticker,
  enabled = true,
}: UsePriceHistoryProps) =>
  useQuery({
    queryKey: [
      QUERY_KEY_PRICE_HISTORY,
      entityTag,
      resolution,
      dateFrom,
      dateTo,
      ticker,
    ],
    queryFn: () =>
      fetchPrices({ entityTag, resolution, dateFrom, dateTo, ticker }),
    staleTime: getTimeTillEndOfDayMs(),
    enabled,
  });
